export const CLAIM_USERID = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
export const CLAIM_NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
export const CLAIM_EMAIL = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
export const CLAIM_ROLE = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
